"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticCheckmarkListNode = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const types_1 = require("./types");
const helpers_1 = require("../helpers");
const scrubHtml = (html) => sanitize_html_1.default(html, { allowedTags: [], allowedAttributes: {} });
const isArrayOfChecks = (array) => {
    if (!Array.isArray(array)) {
        return false;
    }
    for (let i = 0; i < array.length; i++) {
        if (typeof array[i].itemName !== 'string') {
            return false;
        }
        if (typeof array[i].isChecked !== 'boolean') {
            return false;
        }
    }
    return true;
};
const renderCheckmarkList = (rows) => {
    if (!rows)
        return '';
    if (!isArrayOfChecks(rows)) {
        throw new Error('Variable is not a valid list of Checkboxes');
    }
    const inputItems = rows.reduce((acc, value) => acc.concat(`
      <div class="static-checkbox-item">
      <label class="static-checkbox-container">
        ${scrubHtml(value.itemName)}
        <input type="checkbox" disabled="disabled"${value.isChecked ? " checked" : ""}>
        <span class="static-checkmark"></span>
      </label>
      </div>
      `), '');
    return inputItems;
};
const StaticCheckmarkListNode = (config) => ({
    id: config.id,
    type: types_1.NodeTypes.StaticCheckmarkListNode,
    version: 1,
    render: (args) => {
        const value = helpers_1.getKey(args, config.runtimeArgs);
        return renderCheckmarkList(value);
    },
    preview: () => {
        const value = config.attributes.checkboxes;
        return renderCheckmarkList(value);
    },
});
exports.StaticCheckmarkListNode = StaticCheckmarkListNode;
//# sourceMappingURL=data:application/json;base64,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